export default __webpack_public_path__ + "static/media/circuit.2a2e5f74.png";